/**
 * @generated SignedSource<<0e9743f43cb3f180558a13962b2fca7f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftProfileImportCollectionViewNftList_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NftHeartPillProvider_viewer" | "NftProfileImportCollectionViewNftTile_viewer">;
  readonly " $fragmentType": "NftProfileImportCollectionViewNftList_viewer";
};
export type NftProfileImportCollectionViewNftList_viewer$key = {
  readonly " $data"?: NftProfileImportCollectionViewNftList_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftProfileImportCollectionViewNftList_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftProfileImportCollectionViewNftList_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftProfileImportCollectionViewNftTile_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftHeartPillProvider_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "200cf82739b2f9c59691e33a1cf762c3";

export default node;
